export const APPRAISAL_REFRESH_MODULE = 'AppraisalRefreshModule';
// TODO: reconcile COMPOSER_MODULE and SEBS_COMPOSER_MOUNT_KEY into one key after ComposerUiMfe is cleaned up.
export const COMPOSER_MODULE = 'CarvanaComposerUi';
export const SEBS_COMPOSER_MOUNT_KEY = `${COMPOSER_MODULE}-sebs`;
export const SOFTPULL_MODULE = 'SoftPullModule';
